module.exports = __webpack_public_path__ + "media/images/bg/shapes/hex-white-ba47072cefc4c8b885d200b68b3b7c07.svg";